interface IconProps {
  color?: string
}

export function SelectedDocument({ color }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.957 10.065C26.2892 10.4095 26.2793 10.9582 25.9347 11.2904L13.4907 23.2904C13.155 23.6142 12.6233 23.6142 12.2876 23.2905L6.06491 17.2905C5.72035 16.9582 5.71035 16.4096 6.04259 16.065C6.37482 15.7205 6.92347 15.7105 7.26803 16.0427L12.8891 21.4626L24.7315 10.0427C25.0761 9.71049 25.6247 9.72045 25.957 10.065Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
